
import React, { Component } from 'react';
import services from '../../services';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
import { toast } from 'react-toastify';

let combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

class EntityAddress extends Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            AddAddress: false,
            busentdistrito: [],
            busentconcelho: [],
            BusEntFreguesia: [],
            form: {},
            error:null,
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.getDistricList();
    }

    componentDidUpdate(prevProps){
        if(prevProps.date !== this.props.date && prevProps.formValue !== this.props.formValue){
            this.setState({AddAddress : this.props.setAddress , form : this.props.formValue},
                ()=>{
                    if(this.props.formValue.distrito_id){
                        this.getcodconList(this.props.formValue.distrito_id);
                    } else if (this.props.formValue.country_id){
                        this.getcodfrglist(this.props.formValue.country_id);
                    }
                })
        }
    }

    getDistricList = async () => {
        let busentdistrito = [...this.state.busentdistrito]
        let res = await services.apiCall.requestApi("/busentdistrito/GetAll/", combolistrequest, 'post');
        if (res) {
            busentdistrito = res
            this.setState({
                busentdistrito,
            })
        }

    }

    handleChange = (e) => {
        try {
            let form = { ...this.state.form }
            let key = e.target.name;
            let value = e.target.value;
            form[key] = value;
            if (key === "distrito_id") {
                this.getcodconList(value);
            } else if (key === "country_id") {
                this.getcodfrglist(value);
            }
            this.setState({
                form
            })
        } catch (error) {
            this.setState({error})
        }
    }

    getcodconList = async (id) => {
        let busentconcelho = [];
        let res = await services.apiCall.requestApi("/busentconcelho/getbyid/" + id, {}, 'post');
        if (res) {
            busentconcelho = res
        }
        this.setState({
            busentconcelho
        })
    }

    getcodfrglist = async (id) => {
        // id = id.split('-');
        //console.log(id);
        let BusEntFreguesia = [];
        let reqData = {
            districtId : +this.state.form.distrito_id,
            countryId : +id
        }
        let res = await services.apiCall.requestApi("/BusEntFreguesia/GetByID", reqData, 'post');
        if (res) {
            BusEntFreguesia = res
        }
        this.setState({
            BusEntFreguesia
        })
    }

    /*  Para fechar pop-up  */

    closePopup = () => {
        $(".left-popup").trigger('click');
    }

    SaveNewAddress = async () => {
        try {
            let request = { ...this.state.form };
            if (!request.address_line1) {
                toast.error('Morada um campo obrigatório');
                return;
            }
            let entity_id = parseInt(this.props.entity_details.busEntidade.nifap)
            request.pin = parseInt(request.pin);

            // if (!request || request.pin === null) {
            // let country = request.country_id.split("-");
            request.distrito_id = parseInt(request.distrito_id);
            // request.country_id = parseInt(country[1]);
            request.country_id = parseInt(request.country_id);
            request.fregusia_id = parseInt(request.fregusia_id);
            // }
            request.entity_id = entity_id;
            let res;
            if(this.props.billId){
                request.id = this.props.billId
                res = await services.apiCall.requestApi("/Revenue/EditBillingAddess", request);
            }else{
                res = await services.apiCall.requestApi("/Revenue/CreateBillingAddress", request);
            }
            if (res) {
                this.setState({
                    form: {},
                    AddAddress: this.state.AddAddress ? false : true
                }, () => {
                    this.props.getEntityDetails(entity_id);
                    this.props.closePopup();
                }
                )
                this.closePopup();
            }
        } catch (error) {
            this.setState({error})
        }
    }

    AddNewAddress = () => {
        this.setState({
            AddAddress: this.state.AddAddress ? false : true,
            form : {}
        },()=>this.props.updateBillId())
    }

    Cancelar = () => {
        this.setState({
            form: {},
            AddAddress: this.state.AddAddress ? false : true,
        },()=>this.props.updateBillId())
    }
    /*  Para renderizar o conteúdo html da página   */

    render() {
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="row">
                {
                    !this.state.AddAddres &&
                    <Button primary={true} className="success btn-ivdp-primary ml-3" onClick={() => this.AddNewAddress()}>Adicionar Novo Endereço</Button>
                    // <a href="#" className="remoove mr-2" onClick={() => this.AddNewAddress()} >Adicionar Novo Endereço</a>
                }
                {
                    this.state.AddAddress &&
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="input-box active-grey">
                                    <Input
                                        type="text"
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="address_line1"
                                        value={this.state.form.address_line1 || ""}
                                        label="Morada"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="input-box active-grey">
                                    <Input
                                        type="text"
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="address_line2"
                                        value={this.state.form.address_line2 || ""}
                                        label="Localidade"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="input-box active-grey">
                                    <Input
                                        type="text"
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="pin"
                                        value={this.state.form.pin || ""}
                                        label="Código Postal"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="input-box active-grey drop-down-box">
                                    <label className="input-label">Distrito </label>
                                    <select className="custome-drop-down" onChange={(e) => this.handleChange(e)} name='distrito_id' value={this.state.form.distrito_id} >
                                        <option>Selecione Distrito </option>
                                        {
                                            this.state.busentdistrito &&
                                            this.state.busentdistrito.map((_row, index) => (
                                                <option value={_row.coddis}>{_row.desdis}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="input-box active-grey drop-down-box">
                                    <label className="input-label">Concelho</label>
                                    <select className="custome-drop-down" onChange={(e) => this.handleChange(e)} name='country_id' value={this.state.form.country_id}>
                                        <option>Selecione Concelho</option>
                                        {
                                            this.state.busentconcelho &&
                                            this.state.busentconcelho.map((_row, index) => (
                                                <option value={_row.codcon}>{_row.descon}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="input-box active-grey drop-down-box">
                                    <label className="input-label">Freguesia </label>
                                    <select className="custome-drop-down" onChange={(e) => this.handleChange(e)} name='fregusia_id' value={this.state.form.fregusia_id} >
                                        <option>Selecione Freguesia </option>
                                        {
                                            this.state.BusEntFreguesia &&
                                            this.state.BusEntFreguesia.map((_row, index) => (
                                                <option value={_row.dicofre}>{_row.desfrg}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                            </div>
                            <div className="col-md-2">
                                <Button primary={true} className="success btn-ivdp-primary mr-2" onClick={() => this.SaveNewAddress()}>{this.props.billId ?"Atualizar":"Guardar"}</Button>
                                {/* <a href="#" className="remoove mr-2" onClick={() => this.SaveNewAddress()} >Guardar</a>  */
                                }

                            </div>
                            <div className="col-md-2">
                                <Button onClick={() => this.Cancelar()} primary={true} className="remoove btn-ivdp-secondary" >Cancelar</Button>

                                {/* <a href="#" className="remoove mr-2" onClick={() => this.Cancelar()} >Cancelar</a>  */
                                }
                            </div>
                            <div className="col-md-4">
                            </div>
                        </div>
                    </div>
                }
            </div>
        )

    }
}

export default EntityAddress;